export default "__VITE_ASSET__BNd_fD8x__"